import { VISIT_TERMINAL } from '../vmsConstants';

// Which transition a visit can take is decided entirely by its current status,
// and the API enforces that with a hard guard on every endpoint. Rather than
// scatter those rules through the list and the detail screen, they live here
// once and both read from the same table.
//
// This matters more than usual on visits: the server picks the *initial* status
// from the visitor's block flag, a matching pre-approval, a matching gate pass
// and the society's gate entry mode. A DIRECT_ENTRY society hands back a visit
// that is already CHECKED_IN, so a UI that assumed "new visit ⇒ pending
// approval" would offer a check-in button that always 400s.

export const VISIT_ACTIONS = {
    approve: {
        key: 'approve',
        label: 'Approve',
        icon: 'mdi:check',
        from: ['PENDING_APPROVAL'],
        tone: 'tw-text-emerald-600 hover:tw-bg-emerald-50',
        solid: 'tw-bg-emerald-600 hover:tw-bg-emerald-700',
    },
    reject: {
        key: 'reject',
        label: 'Reject',
        icon: 'mdi:close',
        from: ['PENDING_APPROVAL'],
        tone: 'tw-text-rose-600 hover:tw-bg-rose-50',
        solid: 'tw-bg-rose-600 hover:tw-bg-rose-700',
    },
    verifyOtp: {
        key: 'verifyOtp',
        label: 'Verify OTP',
        icon: 'mdi:shield-key-outline',
        from: ['PENDING_OTP'],
        tone: 'tw-text-violet-600 hover:tw-bg-violet-50',
        solid: 'tw-bg-violet-600 hover:tw-bg-violet-700',
    },
    checkIn: {
        key: 'checkIn',
        label: 'Check in',
        icon: 'mdi:login',
        from: ['APPROVED'],
        tone: 'tw-text-sky-600 hover:tw-bg-sky-50',
        solid: 'tw-bg-sky-600 hover:tw-bg-sky-700',
    },
    checkOut: {
        key: 'checkOut',
        label: 'Check out',
        icon: 'mdi:logout',
        from: ['CHECKED_IN'],
        tone: 'tw-text-orange-600 hover:tw-bg-orange-50',
        solid: 'tw-bg-orange-600 hover:tw-bg-orange-700',
    },
};

export const availableActions = (visit) =>
    Object.values(VISIT_ACTIONS).filter(a => a.from.includes(visit?.status));

// A visit can be edited in any status — the API puts no guard on PUT — but
// editing a closed visit is almost always a mistake, so the screens only offer
// it while the visit is still live.
export const canEditVisit = (visit) => !VISIT_TERMINAL.includes(visit?.status);

// DELETE forces CANCELLED from any status, including CHECKED_IN — the API will
// cancel a visitor who is currently inside with no check-out recorded. The
// screens warn before that specific case.
export const cancelLeavesVisitorInside = (visit) => visit?.status === 'CHECKED_IN';

export const canCancelVisit = (visit) =>
    !!visit && !['CANCELLED'].includes(visit.status);
